import { loadGoogleAnalytics } from '@lib/google-analytics';
import { loadGTMScript } from '@lib/google-tag-manager';
import { isPublicTrackingHost } from 'mt-shared';

export interface IAnalyticsScriptLoaders {
  loadGoogleAnalytics: () => void;
  loadGTMScript: () => void;
}

const DEFAULT_LOADERS: IAnalyticsScriptLoaders = { loadGoogleAnalytics, loadGTMScript };

/**
 * Loads the Google Analytics and Google Tag Manager bootstrap scripts, except
 * on the anonymous tracking hosts (`tracking.` / `trace.`, see mt-shared's
 * `isPublicTrackingHost`).
 *
 * GTM container GTM-5C6K8FZ runs a tag that writes a unique `_gd<timestamp>`
 * cookie on the parent domain on every load. On the anonymous tracking/trace
 * hosts there is no visitor to track, and the accumulation breaks the page
 * (S3 rejects header sections over 8 KB). Gated on those two hosts rather
 * than all public access so path-based public pages keep reporting. AG-9932.
 *
 * `loaders` is injectable so the host gate can be unit tested without
 * touching the network; production callers use the defaults.
 */
export function loadAnalyticsScripts(
  hostname: string = window.location.hostname,
  loaders: IAnalyticsScriptLoaders = DEFAULT_LOADERS,
): void {
  if (isPublicTrackingHost(hostname)) return;

  loaders.loadGoogleAnalytics();
  loaders.loadGTMScript();
}
